import axiosInstance from "../../axios/instance";

/**
 * @description Fetch the EUR/USD rate from the API
 * @returns {Promise<{date: string, time: string, rate: number, base: string, quote: string} | null>}
 */

export async function fetchEurUsdRate() {
    try {
      const url = new URL(process.env.REACT_APP_HUB_URL + '/api/currency');
      const response = await axiosInstance.get(url.toString());

      if (!response?.data?.success) {
        return null;
      } 
      return response.data.data;
    } catch (err) {
      console.error('Error fetching currency:', err.message);
      return null;
    }
  }
